import { render, staticRenderFns } from "./boost.vue?vue&type=template&id=dc492ca4&"
import script from "./boost.vue?vue&type=script&lang=js&"
export * from "./boost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports